import React, { FC } from 'react';
import cn from 'classnames';
import css from './styles.module.scss';
import Loader from '.';

const LoaderWrapper: FC = () => (
  <div className={cn(css.loaderWrapper ,'LoaderWrapper')}><Loader/></div>
);

export default LoaderWrapper;
